import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const featureTournamentList = (data) => {
    return instance.post(`${base_apis.tournament}/featured-list`, data)
        .then((res) => {
            return res;
        });
};

export const tournamentList = (data) => {
    return instance.post(`${base_apis.tournament}/list`, data)
        .then((res) => {
            return res;
        });
};

export const tournamentRules = (data) => {
    return instance.get(`${base_apis.tournament}/rules/${data}`)
        .then((res) => {
            return res;
        });
};

export const tournamentPricePointPool = (data) => {
    return instance.get(`${base_apis.tournament}/prizePool/${data}`)
        .then((res) => {
            return res;
        });
};

export const tournamentByCode = (data) => {
    return instance.post(`${base_apis.tournament}/eventByCode`, data)
        .then((res) => {
            return res;
        });
};

export const tournamentRoundsById = (data) => {
    return instance.post(`${base_apis.tournament}/tournamentRoundsById/${data}`)
        .then((res) => {
            return res;
        });
};

export const tournamentMatchByRoundId = (id, data) => {
    return instance.post(`${base_apis.tournament}/matchesById/${id}`, data)
        .then((res) => {
            return res;
        });
};

export const tournamentJoin = (data) => {
    return instance.post(`${base_apis.gamerjiTournament}/join`, data)
        .then((res) => {
            return res;
        });
};


export const getTournamentDetails = (id, data) => {
    return instance.post(`${base_apis.tournamentInfo}/${id}`, data)
        .then((res) => {
            return res;
        });
};

export const myTournamentList = (data) => {
    return instance.post(`${base_apis.tournament}/my-list`, data)
        .then((res) => {
            return res;
        });
};


export const getTableImage = (id, data) => {
    return instance.post(`${base_apis.tournamentTableImage}/${id}`, data)
        .then((res) => {
            return res;
        });
};

export const getRules = (id, data) => {
    return instance.post(`${base_apis.tournamentRules}/${id}`, data)
        .then((res) => {
            return res;
        });
};
export const getTournamentRoundDetails = (id, data) => {
    return instance.post(`${base_apis.tournamentRound}`, data)
        .then((res) => {
            return res;
        });
};

export const getTournamentPlayerDetails = (id, data) => {
    return instance.post(`${base_apis.tournamentLeaderBoard}`, data)
        .then((res) => {
            return res;
        });
};